"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Tabs = _interopRequireDefault(require("./Tabs"));
var _default = _Tabs.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tabs/lib/index.js
// module id = 746
// module chunks = 0